import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
import './utils/setRem.ts'
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Toast } from "antd-mobile";
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";


Toast.config({
  mask: false
})
const antdConfig = {
  locale: zhCN,
}

ReactDOM.render(
  // <React.StrictMode>
  <ConfigProvider {...antdConfig}>
    <App />
  </ConfigProvider>,
  // </React.StrictMode>
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
